import { Icon, type IconName } from "@msuite/ui/icons";
import { cn } from "@msuite/ui/utils";
import type { IncomingInvoiceCheckListItem } from "@msuite/utils/types";

/** A check's state, or `unchecked` while the invoice has no outcome for it yet. */
export type IncomingInvoiceCheckBadgeState = IncomingInvoiceCheckListItem["state"] | "unchecked";

/** Props Interface */
interface IncomingInvoiceCheckBadgeProps {
	state: IncomingInvoiceCheckBadgeState;
}

const STATE_ICON: Record<IncomingInvoiceCheckBadgeState, IconName> = {
	passed: "Check",
	failed: "X",
	skipped: "Minus",
	unchecked: "Dot",
};

// Full class strings per state, so Tailwind finds every one of them in the source.
const STATE_BADGE: Record<IncomingInvoiceCheckBadgeState, string> = {
	passed: "bg-emerald-500",
	failed: "bg-red-500",
	skipped: "bg-gray-400",
	unchecked: "border border-dashed border-color animate-spin",
};

const STATE_ICON_STROKE: Record<IncomingInvoiceCheckBadgeState, string> = {
	passed: "stroke-white",
	failed: "stroke-white",
	skipped: "stroke-white",
	unchecked: "opacity-30",
};

/** The round mark a review check's state is shown as. */
export function IncomingInvoiceCheckBadge({ state }: IncomingInvoiceCheckBadgeProps) {
	/** Render */
	return (
		<div
			className={cn(
				"flex-center rounded-full shrink-0",
				// The unchecked badge trades a pixel of padding for its border, so every badge is the
				// same size.
				state === "unchecked" ? "p-[3px]" : "p-1",
				STATE_BADGE[state],
			)}
		>
			<Icon
				className={STATE_ICON_STROKE[state]}
				name={STATE_ICON[state]}
			/>
		</div>
	);
}
